import { render } from "./FormularioFamilias.vue?vue&type=template&id=5612bd56&ts=true"
import script from "./FormularioFamilias.vue?vue&type=script&lang=ts"
export * from "./FormularioFamilias.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/IAM-PlanCorresponsables/IAM-PlanCorresponsables/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__